import React from 'react';
import { Dialog } from '@mui/material';
import Box from '../single_component/Box';
import Text from '../single_component/Text';
import Button from '../single_component/Button';

interface UnsavedChangesModalProps {
  open: boolean;
  onStay: () => void;
  onLeave: () => void;
}

const UnsavedChangesModal = ({
  open,
  onStay,
  onLeave,
}: UnsavedChangesModalProps) => {
  return (
    <Dialog maxWidth="sm" open={open} onClose={onStay} scroll="paper">
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          padding: 3,
          textAlign: 'center',
          alignItems: 'center',
          gap: 2.5,
          width: 480,
        }}>
        <Text style={{ fontSize: 20, fontWeight: 700, color: '#104960' }}>
          Unsaved Changes
        </Text>
        <Text style={{ fontSize: 14, color: '#667085', width: '90%' }}>
          You have unsaved changes. If you leave this page, your changes will be
          lost. Are you sure you want to continue?
        </Text>
        <Box
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '90%',
            gap: 2,
          }}>
          <Button
            extra={{ variant: 'contained' }}
            onClick={onStay}
            style={{ width: '48%', paddingBlock: 1 }}>
            Stay on Page
          </Button>
          <Button
            extra={{ variant: 'outlined' }}
            onClick={onLeave}
            style={{ width: '48%', paddingBlock: 1 }}>
            Leave Without Saving
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default UnsavedChangesModal;
